import { render, staticRenderFns } from "./PromoBundleSuggestedPrice.vue?vue&type=template&id=47e3bc10&scoped=true&"
import script from "./PromoBundleSuggestedPrice.vue?vue&type=script&lang=js&"
export * from "./PromoBundleSuggestedPrice.vue?vue&type=script&lang=js&"
import style0 from "./PromoBundleSuggestedPrice.vue?vue&type=style&index=0&id=47e3bc10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e3bc10",
  null
  
)

export default component.exports